import { StyleSheet } from 'react-native'

export const styles = StyleSheet.create({
  informationGame: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: 10,
    paddingHorizontal: 30,
    paddingTop: 30,
    paddingBottom: 16
  }
})
